var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blue-shadow3"},[_c('img',{attrs:{"src":require("assets/card-shadow.png")}})])
}]

export { render, staticRenderFns }